import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { DatePicker, Flex, Icon } from 'ui';
import moment from 'utils/cops-moment';
import { dayViews, viewIds } from '../../../config/view';

const LeftIcon = styled(Icon)`
  margin-left: 20px;
  margin-right: 10px;
`;

const RightIcon = styled(Icon)`
  margin-right: 20px;
  margin-left: 10px;
`;

const StyledFlex = styled(Flex)`
  height: 40px;
  .ant-picker-dropdown {
    top: 35px !important;
  }
`;

const StyledFooter = styled.p`
  text-align: center;
  text-decoration: underline;
  color: #0098cc;
  cursor: pointer;
`;

const HeaderDatePicker = ({
  dateReference,
  view,
  setDateReference,
  setViewWorkingDays,
}) => {
  const [dateValue, setDateValue] = useState();
  const [datePickerType, setDatePickerType] = useState('week');
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [format, setFormat] = useState();

  const toDate = (date) => {
    const { calendarType } = view;

    if (calendarType === 'day') {
      return moment()
        .year(date.year)
        .month(date.month)
        .date(date.day);
    }

    if (calendarType === 'month') {
      return moment()
        .year(date.year)
        .month(date.month)
        .startOf('month');
    }
    return moment()
      .year(date.year)
      .month(date.month)
      .date(date.day)
      .startOf('week');
  };

  useEffect(() => {
    if (dateReference) {
      setDateValue(dateReference);
    }
  }, [dateReference]);

  useEffect(() => {
    if (datePickerType === 'month') {
      setFormat('MM ');
    } else if (datePickerType === 'week') {
      setFormat('[W]w ');
    } else {
      setFormat('DD/MM/');
    }
  }, [datePickerType]);

  const handleDateSelect = (date) => {
    const { id, calendarType } = view;
    const currentMoment = dayViews.includes(id) ? date : date.startOf(calendarType);
    const reference = {
      day: currentMoment.date(),
      week: currentMoment.week(),
      month: currentMoment.month(),
      year: parseInt(currentMoment.format('YYYY'), 10),
    };
    if (id === viewIds.oneDay) {
      setViewWorkingDays([currentMoment.day()]);
    }
    if (id === viewIds.twoDays) {
      setViewWorkingDays([currentMoment.day(), currentMoment.day() + 1]);
    }

    setDateReference(reference);
  };

  useEffect(() => {
    if (view?.calendarType) {
      setDatePickerType(view?.calendarType === 'day' ? 'date' : view?.calendarType);
    }
  }, [view?.id]);

  const handleArrowClick = (toNext) => {
    const { id, calendarType } = view;
    let currentMoment = toDate(dateValue);
    currentMoment = toNext ?
      currentMoment.add(1, calendarType) :
      currentMoment.subtract(1, calendarType);

    setDateReference({
      day: currentMoment.date(),
      week: currentMoment.week(),
      month: currentMoment.month(),
      year: currentMoment.year(),
    });

    const dayNumber = currentMoment.day();
    if (id === viewIds.oneDay) {
      setViewWorkingDays([dayNumber]);
    }
    if (id === viewIds.twoDays) {
      setViewWorkingDays([dayNumber, dayNumber + 1]);
    }
  };

  const handleFooterClick = () => {
    const { id, calendarType } = view;
    const dateRef = dayViews.includes(id) ? moment() : moment().startOf(calendarType);
    const reference = {
      day: dateRef.date(),
      week: dateRef.week(),
      month: dateRef.month(),
      year: parseInt(dateRef.format('YYYY'), 10),
    };

    setDateReference(reference);
    setIsDatePickerOpen(false);
  };

  const renderFooter = () => {
    if (datePickerType === 'date') {
      return (
        <StyledFooter onClick={handleFooterClick}>
          <FormattedMessage id='planningBoard.TODAY' />
        </StyledFooter>
      );
    }

    if (datePickerType === 'month') {
      return (
        <StyledFooter onClick={handleFooterClick}>
          <FormattedMessage id='planningBoard.THIS_MONTH' />
        </StyledFooter>
      );
    }

    return (
      <StyledFooter onClick={handleFooterClick}>
        <FormattedMessage id='planningBoard.THIS_WEEK' />
      </StyledFooter>
    );
  };

  const showDatePicker = () => {
    const value = dateValue ? toDate(dateValue) : moment();
    const formatValue = `${format}${value?.weekYear()}`;

    return <DatePicker
      picker={datePickerType}
      onChange={handleDateSelect}
      value={value}
      format={formatValue}
      open={isDatePickerOpen}
      allowClear={false}
      onOpenChange={status => setIsDatePickerOpen(status)}
      renderExtraFooter={renderFooter}
    />;
  };

  return (
    <StyledFlex jcc aic>
      <LeftIcon type='chevron-left' size='lg' onClick={() => handleArrowClick(false)} />
      {showDatePicker(format)}
      <RightIcon type='chevron-right' size='lg' onClick={() => handleArrowClick(true)} />
    </StyledFlex>
  );
};

HeaderDatePicker.propTypes = {
  dateReference: PropTypes.object,
  view: PropTypes.object,
  setDateReference: PropTypes.func,
  setViewWorkingDays: PropTypes.func,
};

export default HeaderDatePicker;
